import PropTypes from "prop-types";
import React from "react";
import GrDrawer from "src/design-system/components/GrDrawer";

// ----------------------------------------------------------------------

export const SORT_BY_OPTIONS = [
  { value: "featured", label: "Featured" },
  { value: "newest", label: "Newest" },
  { value: "priceDesc", label: "Price: High-Low" },
  { value: "priceAsc", label: "Price: Low-High" },
];

// ----------------------------------------------------------------------

CustomDrawer.propTypes = {
  isOpenDrawer: PropTypes.bool,
  onResetDrawer: PropTypes.func,
  onOpenDrawer: PropTypes.func,
  onCloseDrawer: PropTypes.func,
};

// Same props as before; the look is the shared GrDrawer (see /design-elements).
export default function CustomDrawer({
  isOpenDrawer,
  onCloseDrawer,
  componentToPassDown,
  pageTitle,
}) {
  return (
    <GrDrawer
      open={isOpenDrawer}
      onClose={onCloseDrawer}
      title={pageTitle}
      className="forms-drawer event-title"
      flush
    >
      <div className="responce-messages">{componentToPassDown}</div>
    </GrDrawer>
  );
}
